<template>
    <div class="xhdetaily">
        <div class="header">
            <img :src="detail.imgurl" alt="">
        </div>
        <div class="body">
            <div class="tabs">
                <div class="dt">
                    <div>
                        <div>{{freenum}}</div>
                        <div>剩余抽卡次数</div>
                    </div>
                    <div>
                        <div><span>{{usernum}}</span>/<span>{{drawlist.length}}</span></div>
                        <div>已收集卡牌</div>
                    </div>
                </div>
                <!-- <div class="metail">
                    <div>{{metals.gold}}</div>
                    <div>{{metals.silver}}</div>
                    <div>{{metals.bronze}}</div>
                </div> -->
                <div class="draw" v-if="acid" @click="godraw"></div>
                <!-- <div :class="[active==item.id?'active':'','tab']" @click="active = item.id" v-for="item in tablist" :key="item.id">{{item.name}}</div> -->
            </div>
            <div class="centent">
                <div class="rule">
                    <div class="sh"></div>
                    <div class="notice">每日参与AI运动 ，赢取抽卡次数</div>
                </div>
                <div class="vrule" @click="showRule=true">活动规则</div>
                <div class="html">
                    <template>
                        
                        <div class="sublist">
                            <div class="citem" @click="godetail(item)" v-for="item in sublist">
                                <div class="tt">
                                    <div>{{item.title}}</div>
                                    <div><van-icon name="clock-o" />{{item.start_time_show}} ~ {{item.end_time_show}}</div>
                                </div>
                                <div class="img"></div>
                            </div>
                        </div>
                    </template>
                        
                    <!-- <div v-html="active==1?detail.disclaimer:detail.intro"></div> -->
                </div>
            </div>
            <!-- <div class="foot">
                <img @click="godetail()" src="https://oss.mcloud.moveclub.cn/alphamovecloud/20221027/1666841086/532733.png" alt="">
            </div> -->
        </div>
        <van-dialog
            v-model="showRule"
            title="活动规则"
            :style="{width:'80vw' }"
            round
            close-on-click-overlay
            >
            <div style="padding:0rem;overflow: scroll;height:70vh;" v-html="rule"></div>
        </van-dialog>
    </div>
</template>

<script>
import moment from "moment";
import "./index.less";
export default {
    props: ["itemid","acid"],
    data() {
        return {
            showRule: false,
            detail: {},
            tablist: [
                {
                    id: 1,
                    name: '活动规则'
                },{
                    id: 2,
                    name: '奖励办法'
                }
            ],
            sublist: [],
            rule: '',
            title: '',
            active: 1,
            freenum: 0,
            drawlist: [],
            usernum: 0,
            metals: {}
        };
    },
    methods: {
        godraw() {
            wx.miniProgram.navigateTo({
                url: '/v2/activity/drawlist/detail?acid='+this.acid
            });
        },
        godetail(item) {
            this.$router.push({name:'sportsDetail',params:{sports_id:item.sports_id,item_sub_id:item.id}})
        },
        init: function () {
            this.$toast.loading({
                duration: 0,
            });
            this.$api.sports.getItemSubs({ itemid: this.itemid }).then((res) => {
                if(res.status==200){
                    this.sublist = res.data.list;
                    this.title = res.data.title;
                    this.detail = res.data;
                    this.rule = res.data.rule
                    if (+res.data.list.length === 1) {
                        let {
                            title,
                            start_time,
                            end_time,
                            vote_start_time,
                            vote_end_time,
                        } = res.data.list[0];
                        this.enableActivity = res.sys_time > start_time;
                    }
                }
            });
        },
        getdraw() {
            this.$api.activity.activityDetail({acid:this.acid}).then(res=>{
                if(res.status == 200) {
                    this.freenum = res.data.freenum
                    this.drawlist = res.data.list
                    this.usernum = 0
                    res.data.list.forEach(item=>{
                        if(item.jackpotOrder.length) this.usernum++
                    })
                }
            })
        },
        // getmetal() {
        //     this.$api.common.getMetals().then(res=>{
        //         this.metals = res.data[0]
        //     })
        // }
    },
    mounted() {
        this.init();
        // this.getmetal()
        if(this.acid) {
            this.getdraw()
        }
    },
}
</script>